import {SlotScene} from 'slot-scene';
import SlotWinPresenter from './japan-presenter';
import slotConfig from 'cfg/slot-config';

import {Commands}from 'commands';
import {SmartObject} from 'commands';

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

export default class MainScene extends SlotScene {

    constructor (spec, math) {
        super(spec, math, slotConfig);
    
        this.maingameBackground = new Sprite(TextureCache["res/mainbackground.jpg"]);
        this.addChild(this.maingameBackground);
        
        this.addChild(this.barrelContainer);

        this.logo = new Sprite(TextureCache["res/logo.png"]);
        this.logo.anchor.x = 0.5;
        this.logo.position.set(512, 583);
        this.addChild(this.logo);
        
        this.currentWinLabel = new BitmapText("", {font: "impact_font"});
        this.addChild(this.currentWinLabel);
        this.currentWinLabel.position.set(512, -50);
        this.currentWinLabel.anchor.set(0.5, 0);
        this.currentWinLabel.visible = false;
        
        this.slotPresenter = new SlotWinPresenter(math, slotConfig, this /*delegate*/);
        this.addChild(this.slotPresenter);
        
        this.slotPresenter.showBarrelElement = idx => {
            this.barrel.showSymbolWithIndex(idx);
        };
        
        this.slotPresenter.hideBarrelElement = idx => {
            this.barrel.hideSymbolWithIndex(idx);
        };

        this.tableBeforeBonus = new Sprite(TextureCache["table_before_bonus.png"]);
        this.tableBeforeBonus.anchor.set(0.5, 0.5);
        this.tableBeforeBonus.position.set(1024/2, 768/2 - 50);
        this.tableBeforeBonus.visible = false;
        this.addChild(this.tableBeforeBonus);

        this.pressStart = new Sprite(TextureCache["press_start.png"]);
        this.pressStart.anchor.x = 0.5;
        this.pressStart.position.set(0, 80);
        this.tableBeforeBonus.addChild(this.pressStart);

        this.extraLife = new Sprite(TextureCache['res/extra_life.png']);
        this.extraLife.position.set(931, 567 - 50);
        this.extraLife.visible = false;
        this.addChild(this.extraLife);

        this.sndLines = [];
        for (let i = 0; i < 5; ++i) {
            this.sndLines.push(sounds.get("res/sounds/lines/lines_" + i));
        }
        
        this.sndBetUp = sounds.get("res/sounds/bet_up");
        this.sndBetDown = sounds.get("res/sounds/bet_down");
        
        this.sndCredits = sounds.get("res/sounds/credits");
        
        this.sndSpin = [];
        for (let i = 0; i < 3; ++i) {
            this.sndSpin.push(sounds.get("res/sounds/spin/spin_%d".$(i)));
        }

        this.sndScatter = [];
        for(let i = 0; i < 5; i++) {
            this.sndScatter.push(sounds.get("res/sounds/scatters/scatter_%d".$(i)));
        }

        this.currentSpinSnd = 0;
        
        this.sndReelStop = [];
        for (let i = 0; i< 5; ++i){
            this.sndReelStop.push(sounds.get("res/sounds/bar_stop/bar_stop_" + i));
        }

        this.sndWinflow = sounds.get("res/sounds/winflow");

        this.sndSymbols = [];
        for(let i = 0; i < slotConfig.barrel.symbolsCount; ++i) {
            this.sndSymbols.push(sounds.get("res/sounds/symbols/symbol_" + i));
        }

        this.sndClock = sounds.get("res/sounds/clock_tick");
        this.sndClock.loop(true);

        this.sndShowTable = sounds.get("res/sounds/show_table");
        this.sndShowTable.loop(true);

        this.previousScattersCount = null;
        this.symbols = [];
    }

    terminate () {

        if (this.timerBonusStart) {
            clearTimeout(this.timerBonusStart);
        }

        this.slotPresenter.terminate();
        this.slotPresenter = null;

        this.sndWinflow.stop();
        this.sndSpin.forEach(snd => {snd.stop()});
        this.sndSymbols.forEach(snd => snd.stop());
        this.sndScatter.forEach(snd => snd.stop());
        this.sndShowTable.stop();
        this.sndClock.stop();

        this.removeChildren();
        this.destroy();
        
        this.maingameBackground = null;
        this.previousScattersCount = null;
        this.symbols = null;
        this.logo = null;
        this.currentWinLabel = null;
        this.tableBeforeBonus = null;
        this.pressStart = null;
        this.extraLife = null;
        this.sndLines = null;
        this.sndBetUp = null;
        this.sndBetDown = null;
        this.sndCredits = null;
        this.sndSpin = null;
        this.sndReelStop = null;
        this.sndWinflow = null;
        this.sndSymbols = null;
        this.sndClock = null;
        this.sndShowTable = null;
    }

    update(dt, time) {
        super.update(dt, time);

    }
    
    setBarrel (barrel) {
        super.setBarrel(barrel);
        barrel.setCurrentElements([0, 1, 2, 3, 4, 5, 6, 5, 4, 6, 7, 8, 3, 4, 5]);
        barrel.setBlurSpeed(5600);
        barrel.setBlurRotationTime(0.23);
        // for (let i = 0; i < 5; ++i) {
        //     barrel.reels[i].setBlurElements([0,1,2,3,4,5,6,7,8,9,10,11]);
        // }
    };
    
    showWinBeforeBonus (stageMath, done) {
        
        this.math.spin(stageMath.math.symbols, stageMath.bet.lines, stageMath.bet.multiplier);
        this.slotPresenter.showWinBeforeExtraGames(this.slotPresenter, this.math, () => {this.showBonusTable(done)}, false);

    }
    
    startSpin () {

        this.previousScattersCount = 0;

        super.startSpin(this);
        this.currentSpinSnd++;
        this.currentSpinSnd = this.currentSpinSnd % this.sndSpin.length | 0;
        this.sndSpin[this.currentSpinSnd].play();
    }

    // реакция на получение данных
    dataDidReceived(mathStage) {
        this.symbols = mathStage.symbols.slice();
    };
    
    barrelDidStop () {
        
        let sound = this.sndSpin[this.currentSpinSnd];
        
        let fadeOutTween = new TWEEN.Tween(sound)
            .to({volume: 0}, 200)
            .onComplete(function () {
                sound.stop();
                sound.volume = 1.0;
            })
            .start();
    }
    
    reelDidStop (index) {
        let hasScatterOnReel = false;

        for (let i = index * 3, max = (index + 1) * 3; i < max; ++i) {
            // если на остановившемся колесе есть скаттер
            if (this.symbols[i] === this.math.scatter) {
                hasScatterOnReel = true;
                break;
            }
        }

        if (hasScatterOnReel) {
            if (index < 3 ||
                index === 3 && this.previousScattersCount >= 1 ||
                index === 4 && this.previousScattersCount >= 2) {
                this.sndScatter[this.previousScattersCount].play();
            }
            else {
                this.sndReelStop[index].play();
            }
                this.previousScattersCount++;
        }
        else {
            this.sndReelStop[index].play();
        }
    }
    
    winShowDidStart(freegames) {

        this.currentWinLabel.visible = true;
        this.currentWinLabel.text = '';
    }

    winShowDidFinish(freegames) {

        this.currentWinLabel.visible = false;
        this.currentWinLabel.text = '';

        this.sndSymbols.forEach(snd => snd.stop());
        this.sndClock.stop();
    }
    
    lineDidShow (line, win, onFirstTime) {
        super.lineDidShow(line, win, onFirstTime);
        if (onFirstTime) {
            let id = this.math.lineWinSymbol(line);
            this.sndSymbols[id].play();
        }
        else {
            if (this.startClock) {
                this.startClock();
            }
        }
    };

    lineDidHide(line) {
        let id = this.math.lineWinSymbol(line);
        this.sndSymbols[id].stop();
    };

    scattersDidShow(win, atFirst) {
        super.scattersDidShow(win);

        if (atFirst) {
            this.sndSymbols[this.math.scatter].play();
        }
        else {
            if (this.startClock) {
                this.startClock();
            }
        }
    };

    // startSecondaryShowWin() {
    //     if (this.startClock) {
    //         this.startClock();
    //     }
    // };

    scattersDidHide() {
        this.sndSymbols[this.math.scatter].stop();
        super.scattersDidHide();
    };

    bonusDidShow() {
        this.sndSymbols[this.math.bonus].play();
    };

    showBonusTable(done) {

        this.slotPresenter.showBonusAnimationInfinity();

        this.blinkPressTween = new TWEEN.Tween(this.pressStart)
            .to({alpha: 0}, 500)
            .yoyo(true)
            .repeat(Infinity)
            .easing(TWEEN.Easing.Cubic.InOut);

        this.sndShowTable.play();

        this.pressStart.visible = true;
        this.pressStart.alpha = 1;
        this.blinkPressTween.start();
        this.tableBeforeBonus.visible = true;
        done();
    };

    hideBonusTable(done) {

        this.slotPresenter.stopBonusAnimation();

        if (this.blinkPressTween) {
            this.blinkPressTween.stop();
        }
        this.pressStart.alpha = 1.0;
        this.tableBeforeBonus.visible = false;

        this.sndShowTable.stop();

        done();
    };

    switchToMainGame (stageMath, done) {
        this.logo.alpha = 1;
        this.logo.visible = true;

        done();
    };
}


// WEBPACK FOOTER //
// ./src/mainscene.es6